import React from 'react';
import { AppModal, AppButton } from '@/components/atoms';

interface KoreiModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSelect: (rate: number) => void;
}

// Healthcare burden rates for elderly patients (75 years and older)
const ELDERLY_10_PERCENT = 1;
const ELDERLY_20_PERCENT = 2;
const ELDERLY_30_PERCENT = 3;

const KoreiModal: React.FC<KoreiModalProps> = ({ isOpen, onClose, onSelect }) => {
  return (
    <AppModal
      isOpen={isOpen}
      onClose={onClose}
      title="負担割合を選択してください" // In legacy, this might be in the body, but it's good UX to use modal title
      width={700}
      focusable={{
        focusTriggerAfterClose: false,
      }}
    >
      <div>
        <h3 className="text-lg font-medium mb-6 text-center">
          受診者は75歳以上の後期高齢者なので負担割合を選択してください。
        </h3>
        <div className="flex gap-4 justify-center">
          <AppButton
            type="primary"
            onClick={() => onSelect(ELDERLY_10_PERCENT)}
            style={{ backgroundColor: '#17a2b8', color: '#fff', borderColor: '#17a2b8' }}
          >
            後期高齢者１割
          </AppButton>
          <AppButton
            type="primary"
            onClick={() => onSelect(ELDERLY_20_PERCENT)}
            style={{ backgroundColor: '#17a2b8', color: '#fff', borderColor: '#17a2b8' }}
          >
            後期高齢者２割
          </AppButton>
          <AppButton
            type="primary"
            onClick={() => onSelect(ELDERLY_30_PERCENT)}
            style={{ backgroundColor: '#17a2b8', color: '#fff', borderColor: '#17a2b8' }}
          >
            後期高齢者３割
          </AppButton>
        </div>
      </div>
    </AppModal>
  );
};

export default KoreiModal;
